import React from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../../context/authContext";
// import { FiShield, FiTrendingUp, FiCpu } from "react-icons/fi";
import heroImage from "../../assets/images/resource/crypto.png";

const Hero = () => {
  const { user } = UserAuth();
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-primary/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-secondary/10 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left">
            {/* <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
              <span className="text-sm font-medium text-text-muted">No Trading Commission</span>
            </div> */}

            <h1 className="text-5xl lg:text-7xl font-bold leading-tight mb-6 text-white tracking-tight">
              Next Generation <br />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-secondary to-accent animate-gradient-x">
                ASTRAHACK
              </span>
            </h1>

            <p className="text-lg text-text-muted mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
              Empowering Transactions, Securing Futures. Your trusted gateway to learning and
              mastering blockchain technology with professional-grade tools and insights.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <Link
                to={user ? "/dashboard" : "/login"}
                className="btn-primary flex items-center gap-2 group"
              >
                {user ? "Go to Dashboard" : "Get Started"}
                {/* <FiArrowRight className="group-hover:translate-x-1 transition-transform" /> */}
              </Link>

              <Link
                to="/#about"
                className="px-8 py-3 rounded-full border border-white/10 text-white font-medium hover:bg-white/5 transition-all"
              >
                Learn More
              </Link>
            </div>

            {/* <div className="grid grid-cols-3 gap-6 mt-16 pt-8 border-t border-white/5">
              <div className="text-center lg:text-left">
                <h3 className="text-2xl font-bold text-white mb-1">100K+</h3>
                <p className="text-sm text-text-muted">Active Users</p>
              </div>
              <div className="text-center lg:text-left">
                <h3 className="text-2xl font-bold text-white mb-1">$50M+</h3>
                <p className="text-sm text-text-muted">Volume Traded</p>
              </div>
              <div className="text-center lg:text-left">
                <h3 className="text-2xl font-bold text-white mb-1">99.9%</h3>
                <p className="text-sm text-text-muted">Uptime</p>
              </div>
            </div> */}
          </div>

          {/* Visual Content */}
          <div className="flex-1 w-full max-w-lg lg:max-w-xl relative">
            <div className="relative z-10 p-1 rounded-3xl transition-transform duration-500">
              <img
                src={heroImage}
                alt="AstraHack Dashboard Preview"
                className="w-full h-auto drop-shadow-2xl animate-float"
              />
            </div>

            {/* Decoration Elements */}
            <div className="absolute -top-10 -right-10 w-24 h-24 bg-primary/20 rounded-full blur-xl animate-pulse delay-75"></div>
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-secondary/20 rounded-full blur-xl animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
